import { render, staticRenderFns } from "./thirdRiskRegister.vue?vue&type=template&id=83fe7054"
import script from "./thirdRiskRegister.vue?vue&type=script&lang=js"
export * from "./thirdRiskRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83fe7054')) {
      api.createRecord('83fe7054', component.options)
    } else {
      api.reload('83fe7054', component.options)
    }
    module.hot.accept("./thirdRiskRegister.vue?vue&type=template&id=83fe7054", function () {
      api.rerender('83fe7054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/third/risk/thirdRiskRegister.vue"
export default component.exports